import { Flex } from '@buffer-mono/popcorn'

import {
  CommentIcon,
  LikeIcon,
  RepostIcon,
  ShareIcon,
} from '../../../../assets/threads'

import styles from './ThreadPost.module.css'

import type { JSX } from 'react'

export const ThreadPostActions = (): JSX.Element => {
  return (
    <Flex gap="lg" className={styles.actions}>
      <LikeIcon size="small" color="currentColor" />
      <CommentIcon size="small" color="currentColor" />
      <RepostIcon size="small" color="currentColor" />
      <ShareIcon size="small" color="currentColor" />
    </Flex>
  )
}
